import { ButtonProps, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';

import { imgPath } from '~common/utilities/ImgUrl';

import { Messages } from '../../codegen/Localize';

const rotateStyle = style({
  transform: 'rotate(180deg)',
});

export interface ExpandButtonProps {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  ariaControlsId: string; // Set an id for expansion content and pass in as this prop
  style?: React.CSSProperties; // Optional style
}

export function ExpandButton(props: ExpandButtonProps) {
  const buttonProps: ButtonProps = {
    title: Messages.toggleExpand(),
    buttonType: ButtonType.Icon,
    testId: `toggle-expand-button-${props.ariaControlsId}`,
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
    },
    handleClick: () => props.setIsExpanded(!props.isExpanded),
  };
  return (
    <ButtonWidget
      {...buttonProps}
      aria-label={Messages.toggleExpand()}
      aria-expanded={props.isExpanded}
      aria-controls={props.ariaControlsId}
      style={props.style}
    >
      <img src={imgPath('show_nav.svg')} className={props.isExpanded ? rotateStyle : undefined} alt={Messages.toggleExpand()} />
    </ButtonWidget>
  );
}
